var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7 2H5.3C5.13431 2 5 2.13431 5 2.3V2.7C5 2.86569 5.13431 3 5.3 3H13.7C13.8657 3 14 2.86569 14 2.7V2.3C14 2.13431 13.8657 2 13.7 2Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.7 2H2.3C2.13431 2 2 2.13431 2 2.3V2.7C2 2.86569 2.13431 3 2.3 3H2.7C2.86569 3 3 2.86569 3 2.7V2.3C3 2.13431 2.86569 2 2.7 2Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7 13H5.3C5.13431 13 5 13.1343 5 13.3V13.7C5 13.8657 5.13431 14 5.3 14H13.7C13.8657 14 14 13.8657 14 13.7V13.3C14 13.1343 13.8657 13 13.7 13Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.7 13H2.3C2.13431 13 2 13.1343 2 13.3V13.7C2 13.8657 2.13431 14 2.3 14H2.7C2.86569 14 3 13.8657 3 13.7V13.3C3 13.1343 2.86569 13 2.7 13Z",
    fill: "current"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7 9.32996H5.3C5.13431 9.32996 5 9.46427 5 9.62996V10.03C5 10.1956 5.13431 10.33 5.3 10.33H13.7C13.8657 10.33 14 10.1956 14 10.03V9.62996C14 9.46427 13.8657 9.32996 13.7 9.32996Z",
    fill: "current"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.7 9.32996H2.3C2.13431 9.32996 2 9.46427 2 9.62996V10.03C2 10.1956 2.13431 10.33 2.3 10.33H2.7C2.86569 10.33 3 10.1956 3 10.03V9.62996C3 9.46427 2.86569 9.32996 2.7 9.32996Z",
    fill: "current"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7 5.67004H5.3C5.13431 5.67004 5 5.80436 5 5.97004V6.37004C5 6.53573 5.13431 6.67004 5.3 6.67004H13.7C13.8657 6.67004 14 6.53573 14 6.37004V5.97004C14 5.80436 13.8657 5.67004 13.7 5.67004Z",
    fill: "current"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.7 5.67004H2.3C2.13431 5.67004 2 5.80436 2 5.97004V6.37004C2 6.53573 2.13431 6.67004 2.3 6.67004H2.7C2.86569 6.67004 3 6.53573 3 6.37004V5.97004C3 5.80436 2.86569 5.67004 2.7 5.67004Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.a8534295034caac8d1c83850417a3b54.svg";
export { ForwardRef as ReactComponent };